export default {
  viewAll: 'Посмотреть все статьи',
} as const;
